import { forwardRef } from 'react';
import { useMount } from 'react-use';

import { useContextSelector } from 'use-context-selector';
import classNames from 'classnames';
import { useTheme } from 'styled-components';

import { CardContext } from '../Card.context';
import { Icon, IconName, IconSize } from '../../Icon';
import { ThemePaletteColor } from '../../../types';

import styles from './CardIcon.module.scss';

export interface CardIconProps {
  name: IconName;
  size?: IconSize;
  color?: ThemePaletteColor;
}

export const CardIcon = forwardRef<HTMLDivElement, CardIconProps>(
  ({ name, size = 'sm', color = 'periwinkle300' }, ref) => {
    const { palette } = useTheme();

    const setState = useContextSelector(
      CardContext,
      ({ setState }) => setState
    );

    useMount(() => {
      setState((prev) => ({ ...prev, icon: { name, size } }));
    });

    return (
      <div
        ref={ref}
        style={{
          backgroundColor: palette[color],
        }}
        className={classNames(styles.root, styles[size])}
      >
        <Icon name={name} size={size} />
      </div>
    );
  }
);
